import AccessRightsUserDeveloperPage from "../../../component/users/developers/AccessRightsUserDeveloper"

 
 
function AccessRightsUserDeveloper() {
  return (
    <div className="page-body"><AccessRightsUserDeveloperPage/></div>
  )
}

export default AccessRightsUserDeveloper